// /src/pages/NotFound.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED = ['uk','en','it','fr'];

function useCurrentLang() {
  const loc = useLocation();
  const seg = (loc.pathname.split('/').filter(Boolean)[0] || '').toLowerCase();
  return SUPPORTED.includes(seg) ? seg : 'uk';
}

export default function NotFound() {
  const { t } = useTranslation('common');
  const lang = useCurrentLang();
  return (
    <div className="container" style={{ padding: '40px 20px' }}>
      <h1 style={{ marginBottom: 12 }}>{t('not_found.title')}</h1>
      <p style={{ marginBottom: 20 }}>{t('not_found.description')}</p>
      <Link to={`/${lang}/`} style={{ color: 'rgb(0,110,69)', textDecoration: 'none', fontWeight: 600 }}>
        {t('not_found.back_home')}
      </Link>
    </div>
  );
}
